import { makeStyles } from '@material-ui/core/styles';
import { themeColor } from 'src/mui-theme';

interface PassedProps {
  selected: boolean;
}

export const styles = makeStyles(theme => ({
  displayModeButton: ({ selected }: PassedProps) => ({
    border: selected
      ? `2px solid ${theme.palette.secondary.main}`
      : `1px solid ${themeColor.borderGray}`,
    '& > div': {
      color: selected ? themeColor.defaultTextColor : theme.palette.info.main,
    },
  }),
}));
